import React from 'react';
import Tab from '@ertelecom/ui-react/components/tabs/tab';
import * as S from '../styled';
import * as ST from './styled';
import { FilmsCarousel } from '../films-carousel';
import { CarouselTrack } from '~/src/components/CarouselTrack';
import { TrackContent } from '../track-content';
import { useMatchMedia } from '~/src/helpers/hooks/useMatchMedia';
import { sectionData } from './section-data';

const mediaWidthMobile = '(max-width: 640px)';

const renderList = (isMobile) => {
    return (
        sectionData.map(({ id, label, trackData, slidesData }) => (
            <Tab label={label} key={id}>
                <ST.TabContent>
                    <ST.CarouselTrackWrap>
                        {isMobile
                            ?   null
                            :   <CarouselTrack data={trackData} Content={TrackContent} />
                        }
                    </ST.CarouselTrackWrap>
                    <FilmsCarousel data={slidesData} />
                </ST.TabContent>
            </Tab>
        ))
    );
};

export const WatchNow = () => {
    const [isMobile] = useMatchMedia(mediaWidthMobile);

    return (
        <S.Section bgColor='#000'>
            <S.InnerContainer>
                <S.SectionTitle isLight>Смотрите прямо сейчас</S.SectionTitle>
            </S.InnerContainer>
            <ST.TabsWrap>
                <S.STabs isLight>
                    {renderList(isMobile)}
                </S.STabs>
            </ST.TabsWrap>
        </S.Section>
    );
};
